import sizes from 'constants/sizes';

export default {
  scale: window.innerHeight > 720 ? sizes.FULL_HD : sizes.HD,
  mainTransitionDuration: '200ms',
  withAnimation: false,
  mouseIdleTimeout: 10000,
  gaTrackID: 'UA-120921709-3',
  client_id: 'cloud:mometu_smart tv_device',
  logoUrl: 'https://flux.hootko.tv/assets/images/logo-flux.png',
};

export const LIST_ITEMS_SIZE = {
  LARGE: { width: 355, height: 512, metadataHeight: 140 },
  VOD_ASSET: { width: 355, height: 512, metadataHeight: 140 },
  MEDIUM: { width: 355, height: 400, metadataHeight: 0 },
  SMALL: { width: 355, height: 355, metadataHeight: 129 },
  CHANNEL: { width: 355, height: 355, metadataHeight: 129 },
  BANNER: { width: 1265, height: 640, metadataHeight: 0 },
  SEARCH: { width: 230, height: 332, metadataHeight: 34 },
  PROGRAM: { width: 730, height: 410, metadataHeight: 0 },
};
